import dayjs from "dayjs";
import "dayjs/locale/en-gb";

import customParseFormat from "dayjs/plugin/customParseFormat";
import utc from "dayjs/plugin/utc";

dayjs.locale("en-gb");

dayjs.extend(customParseFormat);
dayjs.extend(utc);

export { dayjs };

export const FULL_DATE_FORMAT = "DD-MM-YYYY HH:mm";
export const DATE_FORMAT_WITHOUT_CLOCK = "DD-MM-YYYY";
export const DATE_URL_FORMAT = "YYYY-MM-DD";

// * Backend datetimes are UTC, mostly without an offset. Plotly ignores offsets and plots the wall-clock part
// * of a date string, so graph x values must be handed over in the browser's local time.
export const toLocalGraphTime = (value) => {
    const isNaiveString = typeof value === "string" && !/(Z|[+-]\d{2}:?\d{2})$/i.test(value.trim());
    return (isNaiveString ? dayjs.utc(value) : dayjs(value)).local().format();
};

// * Plain date for `date` path params (the API rejects datetimes there); null when empty or unparseable.
export const toUrlDate = (value) => {
    if (!value) return null;
    const date = dayjs(value);
    return date.isValid() ? date.format(DATE_URL_FORMAT) : null;
};

const firstDate = dayjs(new Date());
export const format = (date, format = FULL_DATE_FORMAT) => {
    const dayjsDate = dayjs(date);
    return firstDate.isSame(dayjsDate) ? "-" : dayjsDate.format(format);
};
export const isAfter = (dateFirst, dateSecond) => dayjs(dateFirst).isAfter(dateSecond);
